module.exports = __webpack_public_path__ + "img/gift_07.18e36b8e.png";